var _style, _g, _g2, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrontEndArchitecture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "front-end-IA",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#2458A6;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#F2644B;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:#F2644B;}\r\n\t.st3{fill:none;stroke:#F2644B;stroke-width:11;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#F2644B;stroke-width:10;stroke-miterlimit:10;}\r\n\t.st5{fill:#F2644B;stroke:#F2644B;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st6{fill:#2458A6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "screen"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.6,118.7v-58c0-0.6,0.4-1.2,0.9-1.2h173.7c0.2,0,0.5,0.1,0.6,0.3c0.2,0.3,0.3,0.7,0.3,0.8 c0,0.7,0,31.5-0.1,73.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.2,112.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236,182.9c0,17.3,0.1,34.5,0.1,51.8c0,0.7-0.4,1.3-0.9,1.3H61.5c-0.5,0-0.9-0.6-0.9-1.3c0-21.4,0-42.8,0-64.2 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 60.6,
    y1: 210.1,
    x2: 236.1,
    y2: 210.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 60.6,
    y1: 96.8,
    x2: 236.1,
    y2: 96.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 76.8,
    cy: 78.6,
    rx: 5.3,
    ry: 5.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 92.6,
    cy: 78.6,
    rx: 5.3,
    ry: 5.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 106.9,
    cy: 78.6,
    rx: 5.3,
    ry: 5.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "boxes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.3,165.3h-38c-1.4,0-2.5-1.1-2.5-2.5v-37c0-1.4,1.1-2.5,2.5-2.5h38c1.4,0,2.5,1.1,2.5,2.5v37 C76.8,164.1,75.7,165.3,74.3,165.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M266.3,179.9h-64.8c-1.4,0-2.5-1.1-2.5-2.5v-37c0-1.4,1.1-2.5,2.5-2.5h64.8c1.4,0,2.5,1.1,2.5,2.5v37 C268.8,178.7,267.7,179.9,266.3,179.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M257.1,155.1H212c-1.2,0-2.2-1-2.2-2.2v-0.1c0-1.2,1-2.2,2.2-2.2h45.1c1.2,0,2.2,1,2.2,2.2v0.1 C259.3,154.1,258.3,155.1,257.1,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M257.1,166.7H212c-1.2,0-2.2-1-2.2-2.2v-0.1c0-1.2,1-2.2,2.2-2.2h45.1c1.2,0,2.2,1,2.2,2.2v0.1 C259.3,165.8,258.3,166.7,257.1,166.7z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M170.6,136.3h-69.8c-2.4,0-4.4-2-4.4-4.4l0,0c0-2.4,2-4.4,4.4-4.4h69.8c2.4,0,4.4,2,4.4,4.4l0,0 C175,134.3,173,136.3,170.6,136.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M170.6,153.3h-69.8c-2.4,0-4.4-2-4.4-4.4l0,0c0-2.4,2-4.4,4.4-4.4h69.8c2.4,0,4.4,2,4.4,4.4l0,0 C175,151.3,173,153.3,170.6,153.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M154.4,171.3h-53.5c-2.4,0-4.4-2-4.4-4.4l0,0c0-2.4,2-4.4,4.4-4.4h53.5c2.4,0,4.4,2,4.4,4.4l0,0 C158.8,169.3,156.8,171.3,154.4,171.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontEndArchitecture);
export default __webpack_public_path__ + "static/media/front-end-architecture.2c10ffb096ce19d787b69d71e00dfc77.svg";
export { ForwardRef as ReactComponent };